:host {
  display: block;
  margin: 2rem 0;
  color: var(--color-text, #222);
}

.poll {
  padding: 1.5rem;
  border: 1px solid #dedede;
  border-radius: 0.75rem;
  background: #fff;
}

.poll__header {
  margin-bottom: 1.25rem;
}

.poll__title {
  margin: 0 0 0.5rem;
  font-size: 1.35rem;
}

.poll__image {
  display: block;
  width: 100%;
  max-height: 22rem;
  margin: 1rem 0;
  border-radius: 0.5rem;
  object-fit: cover;
}

.poll__description {
  margin: 0;
  color: #555;
}

.poll__question {
  margin: 0 0 1rem;
  font-size: 1.1rem;
}

.poll__options {
  display: grid;
  gap: 0.75rem;
  margin: 0;
  padding: 0;
  border: 0;
}

.poll__options legend {
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.poll__option {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  cursor: pointer;
}

.poll__option input {
  flex: 0 0 auto;
  width: 1.1rem;
  height: 1.1rem;
  margin: 0.15rem 0 0;
  accent-color: #df6b36;
}

.poll__answer-label {
  display: grid;
  gap: 0.5rem;
  font-weight: 600;
}

.poll__answer-label textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #bbb;
  border-radius: 0.4rem;
  font: inherit;
  resize: vertical;
}

.poll__submit {
  min-height: 2.75rem;
  margin-top: 1.25rem;
  padding: 0.6rem 1.1rem;
  border: 0;
  border-radius: 0.4rem;
  background: #df6b36;
  color: #fff;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.poll__submit:hover,
.poll__submit:focus-visible {
  background: #bd5123;
}

.poll__submit:focus-visible,
.poll__answer-label textarea:focus-visible,
.poll__option input:focus-visible {
  outline: 2px solid #8e3d1d;
  outline-offset: 2px;
}

.poll__submit:disabled {
  cursor: wait;
  opacity: 0.7;
}

.poll__result + .poll__result {
  margin-top: 1rem;
}

.poll__result-label {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.35rem;
}

.poll__bar-track {
  height: 0.75rem;
  overflow: hidden;
  border-radius: 1rem;
  background: #eee;
}

.poll__bar {
  height: 100%;
  border-radius: inherit;
  background: #df6b36;
  transition: width 250ms ease;
}

.poll__text-results {
  display: grid;
  gap: 0.5rem;
  margin: 0;
  padding-left: 1.25rem;
}

.poll__total {
  margin: 1rem 0 0;
  color: #555;
  font-size: 0.95rem;
}

.poll__status {
  min-height: 1.5em;
  margin: 0.75rem 0 0;
  color: #555;
}

@media (max-width: 480px) {
  .poll {
    padding: 1rem;
  }

  .poll__result-label {
    font-size: 0.95rem;
  }
}
